import React from "react";

const SectionsTabs = ({ activeTab, setActiveTab }) => (
  <div className="d-flex align-items-center mb-3">
   
    <div
      className={`tabs tab me-2 ${activeTab === "templates" ? "active" : ""}`}
      onClick={() => setActiveTab("templates")}
      id="templates"
    >
      Templates
    </div>
    <div
      className={`tabs tab  ${activeTab === "sections" ? "active" : ""}`}
      onClick={() => setActiveTab("sections")}
      id="sections"
    >
      Sections
    </div>
  </div>
);

export default SectionsTabs;
